"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = void 0;
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var _iconsReact = require("../../../icons-react");
var _BlackClock = _interopRequireDefault(require("../../../icons-react/rebrand/BlackClock"));
var _CancellationQuestion = _interopRequireDefault(require("../../../icons-react/rebrand/CancellationQuestion"));
var _CancellationOff = _interopRequireDefault(require("../../../icons-react/rebrand/CancellationOff"));
var _CancellationOn = _interopRequireDefault(require("../../../icons-react/rebrand/CancellationOn"));
var TYPES = exports.TYPES = {
  instantConfirm: {
    order: 2,
    tooltipText: _localization.i18n.t('hotelcard.tag.instant.tooltip'),
    text: _localization.i18n.t('hotelcard.tag.instant.text'),
    tooltipColor: '#1E63E8'
  },
  notToConfirmAtOnce: {
    icon: /*#__PURE__*/_react["default"].createElement(_BlackClock["default"], null),
    order: 2,
    tooltipText: _localization.i18n.t('hotelcard.tag.notToConfirmAtOnce.tooltip'),
    text: _localization.i18n.t('hotelcard.tag.notToConfirmAtOnce.text'),
    tooltipColor: '#B65800'
  },
  freeCancellation: {
    icon: /*#__PURE__*/_react["default"].createElement(_CancellationOn["default"], null),
    order: 3,
    text: _localization.i18n.t('hotelcard.tag.free_cancellation')
  },
  earlyBooking: {
    icon: /*#__PURE__*/_react["default"].createElement(_iconsReact.Clock, null),
    order: 4,
    tooltipText: _localization.i18n.t('hotelcard.tag.early.tooltip'),
    text: _localization.i18n.t('hotelcard.tag.early.text'),
    tooltipColor: '#4b137b'
  },
  crown: {
    order: 6,
    icon: /*#__PURE__*/_react["default"].createElement(_iconsReact.Crown, null)
  },
  rareConfirmation: {
    order: 6
  },
  advantages: {
    order: 6
  },
  fewChance: {
    order: 1
  },
  trustYou: {
    order: 5,
    icon: /*#__PURE__*/_react["default"].createElement(_iconsReact.Done, null)
  },
  filterPenalized: {
    order: 1
  },
  nothingRefund: {
    icon: /*#__PURE__*/_react["default"].createElement(_CancellationOff["default"], null),
    order: 3
  },
  partialRefund: {
    icon: /*#__PURE__*/_react["default"].createElement(_CancellationQuestion["default"], null),
    order: 3
  }
};